export default __webpack_public_path__ + "static/Biker-08d5093450a94f9b8f6a2da0936bf356.png";